import React from 'react';
import BooleanRow from '@library/boolean-row/edit';
import * as c from '../../constants';
import { Modal, ModalBody, ModalFooter } from 'reactstrap';
import { CancelButton, DangerButton } from '@library/Buttons';

type Props = {
  permanentlyClosed: boolean | null;
  setPermanentlyClosed: (v: boolean | null) => void;
};

export const PermanentlyClosed = function(props: Props) {
  const [modalOpen, setModalOpen] = React.useState(false);

  return (
    <>
      <BooleanRow
        segmented
        label={c.PERMANENTLY_CLOSED_LABEL}
        description={c.PERMANENTLY_CLOSED_DESCRIPTION}
        value={props.permanentlyClosed}
        onChange={val => val === true ? setModalOpen(true) : props.setPermanentlyClosed(val)}
      />
      <Modal
        className="boone-listing__disable-modal"
        isOpen={modalOpen}
        toggle={() => setModalOpen(false)}
      >
        <ModalBody className="m-4 mr-3">{c.PERMANENTLY_CLOSED_MODAL_BODY}</ModalBody>
        <ModalFooter>
          <CancelButton
            cy="permanently-closed-cancel"
            onCancel={() => setModalOpen(false)}
          />
          <DangerButton
            onClick={() => {
              props.setPermanentlyClosed(true);
              setModalOpen(false);
            }}
          >
            {'Set as permanently closed'}
          </DangerButton>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default PermanentlyClosed;
